import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { PrediccionesRealizadas } from '../models/predicciones-realizadas';
import { EvaluarPrediccionRequest } from '../models/evaluar-prediccion-request';
import { PrediccionEvaluada } from '../models/prediccion-evaluada';

@Injectable({
  providedIn: 'root'
})
export class PronosticoService {
  private apiUrl = `${environment.webApiUrl}api/Predecir`;
  private apiUrlTuLotero = `${environment.webApiUrl}api/TuLotero`;
  private apiUrlMordred = `${environment.apiMordred}api/`;
  constructor(private http: HttpClient) {}
  predecir(juego: string): Observable<any> {
    return this.http.get<any>(this.apiUrl+'/'+juego);
  }
  predecirString(juego: string): Observable<string> {
    return this.http.get(this.apiUrl + '/' + juego, { responseType: 'text' });
  }
  obtenerResultadosString(): Observable<string> {
    return this.http.get(this.apiUrlTuLotero, { responseType: 'text' });
  }
  obtenerMordredPrediccion(sufijo: string): Observable<string> {
    return this.http.get(this.apiUrlMordred+'Prediccion/'+sufijo, { responseType: 'text' });
  }
  obtenerMordredPrediccionPost(model: PrediccionesRealizadas,sufijo: string): Observable<any> {
    return this.http.post(this.apiUrlMordred + 'Prediccion/'+sufijo, model);
  }
  evaluarEfectividadPredicciones(body: EvaluarPrediccionRequest): Observable<PrediccionEvaluada[]> {
    return this.http.post<PrediccionEvaluada[]>(`${this.apiUrlMordred}Prediccion/evaluar-efectividad-predicciones`, body);
  }
  obtenerPatronPredicciones(body: EvaluarPrediccionRequest): Observable<PrediccionEvaluada[]> {
    return this.http.post<PrediccionEvaluada[]>(`${this.apiUrlMordred}Prediccion/obtener-patron-predicciones`, body);
  }

  consultarUltimaPrediccion(body: EvaluarPrediccionRequest): Observable<PrediccionEvaluada> {
    return this.http.post<PrediccionEvaluada>(`${this.apiUrlMordred}Prediccion/consultar-ultima-prediccion`, body);
  }
}
